<script>
  import { Router, Route, Link, navigate } from "svelte-navigator";
  import {
    API_DIR,
    SESSION_LS,
    selectedDeviceId,
    selectedPage,
    tableData,
    selectorDeviceId,

    selectedDevices

  } from "../store";
  import { onMount } from "svelte";
  import { prevent_default } from "svelte/internal";
  import { getCookieValue } from "../Utils.svelte";
  import { toasts } from "svelte-toasts";

  let inputDeviceId = "";
  let pageLoaded = false;

  /*const showToast = () => {
    const toast = toasts.add({
      title: "Device Not Found",
      description: "The selected device has no matches.",
      duration: 3000, // 0 or negative to avoid auto-remove
      placement: "bottom-right",
      type: "info",
      theme: "light",
      placement: "bottom-right",
      showProgress: true,
      type: "warning",
      theme: "light",
      onClick: () => {},
      onRemove: () => {},
      // component: BootstrapToast, // allows to override toast component/template per toast
    });
  };*/

  function checkForDevice() {
    //console.log($tableData);

    if (pageLoaded) {
      if (inputDeviceId != "") {
        let hasObjectWithId;
        hasObjectWithId = $tableData.find(
          (device) => device.id_device === inputDeviceId
        );

        /*if (hasObjectWithId) {
          //selectedDeviceId.set([inputDeviceId]);
        } else {
          
          selectorDeviceId.set(inputDeviceId);
          selectedPage.set(3);
        }*/
        selectedDevices.set([inputDeviceId]) 
        selectorDeviceId.set(inputDeviceId);
        inputDeviceId = "";
        selectedPage.set(3);

      }
    }
  }

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      checkForDevice();
    }
  }

  /*function goToDeviceTable() {
    if ($tableData.length > 0) {
      selectedPage.set(3);
    }
  }*/

  async function logout() {
    try {
      const response = await fetch(
        `${$API_DIR}/api/v1/logout?sessionID=${localStorage.getItem(
          $SESSION_LS
        )}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Session-Id": localStorage.getItem($SESSION_LS)
          }
        }
      );

      if (response.ok) {
        const data = await response.json();
        localStorage.setItem($SESSION_LS, "");
        location.reload();
      } else if (response.status === 401) {
        location.reload();
      } else {
        throw new Error("Error en la solicitud");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  }

  onMount(async () => {
    selectedPage.set(0);
    pageLoaded = true;
  });
</script>

<div>
  <header style="margin-bottom: 24px;">
    <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
      <div class="container-fluid">
        <a
          class="navbar-brand"
          href={null}
          on:click={() => {
            selectedPage.set(0);
          }}>OMNI PULS</a
        >
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon" />
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav me-auto mb-2 mb-lg-0">
            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Devices
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                  <button
                    type="button"
                    class="btn btn-link"
                    on:click={() => {
                      selectedPage.set(0);
                    }}
                    >Group Selector
                  </button>
                </li>
                <!--<li>
                  <a class="dropdown-item" href="#">VBus &raquo;</a>
                  <ul class="dropdown-menu dropdown-submenu">
                    <li>
                      <a class="dropdown-item">VBus Devices</a>
                    </li>
                    <li>
                      <a class="dropdown-item">VBus Files</a>
                    </li>
                  </ul>
                </li>
                <li>
                  <a class="dropdown-item" href="#">Hosted &raquo;</a>
                  <ul class="dropdown-menu dropdown-submenu">
                    <li>
                      <a class="dropdown-item" href="#">Hosted Apps</a>
                    </li>
                    <li>
                      <a class="dropdown-item" href="#">Hosted Files</a>
                    </li>
                  </ul>
                </li>-->
              </ul>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href={null}
                on:click={() => {
                  selectedPage.set(5);
                }}>Firmware</a
              >
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href={null}
                on:click={() => {
                  selectedPage.set(4);
                }}>Config</a
              >
            </li>

            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Updates
              </a>
              <ul class="dropdown-menu" aria-labelledby="navbarDropdown">
                <li>
                  <button
                    type="button"
                    class="btn btn-link"
                    on:click={() => {
                      selectedPage.set(8);
                    }}
                    >Pending
                  </button>
                </li>

                <li>
                  <button
                    type="button"
                    class="btn btn-link"
                    on:click={() => {
                      selectedPage.set(9);
                    }}
                    >Completed
                  </button>
                </li>

              </ul>
            </li>

            <li class="nav-item">
              <a
                class="nav-link"
                href={null}
                on:click={() => {
                  selectedPage.set(11);
                }}>Campaigns</a
              >
            </li>
          </ul>
          <div class="d-flex">
            <input
              class="form-control me-2"
              placeholder="Device Id"
              bind:value={inputDeviceId}
              on:keyup={handleKeyPress}
            />
            <button
              type="button"
              class="btn btn-outline-success"
              style="min-width: fit-content;"
              on:click={() => {
                checkForDevice();
              }}> <i class="bi bi-search"></i> Find Device</button
            >

            <button
              type="button"
              class="btn btn-outline-secondary"
              style="min-width: fit-content; margin-left:6px"
              data-bs-toggle="tooltip"
              data-bs-placement="bottom"
              title="Logout"
              on:click={() => logout()}
            >
              <i class="bi bi-box-arrow-left" />
            </button>
          </div>
        </div>
      </div>
    </nav>
  </header>
</div>

<style>
  .dropdown-menu li {
    position: relative;
  }
  .dropdown-menu .dropdown-submenu {
    display: none;
    position: absolute;
    left: 100%;
    top: -7px;
  }
  .dropdown-menu .dropdown-submenu-left {
    right: 100%;
    left: auto;
  }
  .dropdown-menu > li:hover > .dropdown-submenu {
    display: block;
  }
</style>
